export default __webpack_public_path__ + "static/media/full2.f45bac03.jpg";